module.exports = __webpack_public_path__ + "static/media/balloon.0a5364a0.png";